<template>
    <v-container class="mw-400">
      <v-card elevation="2">
        <v-card-title class="tableheader white--text">
          <v-icon left color="white">mdi-lock-question</v-icon>
          Forgot Password
        </v-card-title>
        <v-card-text>
          <v-form ref="frm" v-model="valid" @submit.prevent="submit">
            <v-text-field v-model="email" label="Email address" variant="outlined"
                          :rules="[rules.req, rules.email]" />
            <v-btn type="submit" color="primary" :disabled="!valid" :loading="loading">
              Send reset link
            </v-btn>
          </v-form>
          <v-alert v-if="msg" class="mt-4" type="info" border="start">
            {{ msg }}
          </v-alert>
        </v-card-text>
      </v-card>
    </v-container>
  </template>
  
  <script setup>
  import { ref } from 'vue'; import api from '@/services/api';
  const email=ref(''), valid=ref(false), msg=ref(''), loading=ref(false)
  const rules={ req:v=>!!v||'Required', email:v=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)||'Invalid'}
  async function submit(){
    loading.value=true
    await api.post('/auth/forgot-password',{email:email.value})
    msg.value='If that address is registered you will receive an email shortly.'
    loading.value=false
  }
  </script>
  